ui-cms-blog-comment-section {
  display: block;
  padding: 1.5rem 0;

  .comments-count {
    display: block;
    width: 100%;
    text-align: left;
    padding-bottom: 1rem;
    border-bottom: 1px solid $ui-grey;
  }

  .comments {
    padding: 2rem 0;
  }
}
